import { API_URL } from '@constants'
import axiosReadInstance from '../../request/axiosReadInstance'
import { useCallback, useEffect, useState } from 'react'
import logoLt from '../../assets/logo-lt.svg'
import { ArrowRightIcon } from '@heroicons/react/24/solid'
import { replaceImageExtension } from '@utils'
import { Image } from '@types'

interface IDiscoverOffice {
    title: string
    description: string
    office: [
        {
            logo: {
                data: Image
            }
            city: string
            header_region: {
                data: {
                    id: number
                }
            }
        }
    ]
}

export const DiscoverOffice = () => {
    const [discoverOffice, setDiscoverOffice] = useState<IDiscoverOffice>()

    const fetchData = useCallback(async () => {
        await axiosReadInstance
            .get(`${API_URL}/api/discover-office?populate=deep`)
            .then((response) =>
                setDiscoverOffice(response.data.data.attributes)
            )
    }, [])

    useEffect(() => {
        fetchData()
    }, [fetchData])
    return (
        <section className="bg-white  ">
            <div className="py-8 px-4 md:px-[6rem] lg:px-[8rem] mx-auto text-left lg:py-16">
                <h2 className="mb-4 text-lg font-semibold tracking-tight  text-gray-900 md:text-4xl lg:text-5xl   ">
                    {discoverOffice?.title}
                </h2>
                <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-4">
                    {discoverOffice?.office.map((office, index) => (
                        <a
                            className="border-b md:border-0"
                            href={`/office/${office.header_region.data.id}`}
                            style={{ borderColor: '#d6d6dc' }}
                        >
                            <div
                                className="flex md:border md:rounded-[32px] p-2 md:p-4 lg:p-6 hover:bg-gray-100"
                                style={{ borderColor: '#D6D6DC' }}
                            >
                                <div
                                    className="z-10 flex flex-col items-center border rounded-2xl md:rounded-full w-[60px] h-[60px] relative overflow-hidden"
                                    style={{ borderColor: '#fff' }}
                                >
                                    <img
                                        src={replaceImageExtension(
                                            office?.logo.data.attributes.url
                                        )}
                                        alt={
                                            office?.logo.data.attributes
                                                .alternativeText
                                        }
                                        className="z-20 relative w-[150%] max-w-fit"
                                    />
                                </div>
                                <p className="flex items-center text-sm md:text-xl ml-4 font-semibold self-center text-gray-700 ">
                                    {window.innerWidth > 1024 ? (
                                        <span lang="en" translate="no">
                                            Listen too{' '}
                                        </span>
                                    ) : (
                                        <img
                                            className="flex"
                                            src={logoLt}
                                            alt="Listen too"
                                            lang="en"
                                        />
                                    )}

                                    {office.city}
                                </p>
                                <ArrowRightIcon
                                    aria-hidden="true"
                                    className="w-[25px] font-bold ml-auto"
                                    style={{ color: '#0A8335' }}
                                />
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </section>
    )
}
